<template>
  <div>
    <Alert ref="alert"/>
    <Loader ref="loader"/>
    <router-view></router-view>
  </div>
</template>

<script>
import Alert from '@/components/Alert.vue';
import { EventBus } from '@/lib/event-bus';
import Loader from '@/components/Loader.vue';

export default {
  name: 'App',
  data() {
    return {
    };
  },
  components: { Alert, Loader },
  created() {
    EventBus.$on('triggerAlert', (options) => {
      this.triggerAlert(options);
    });
    EventBus.$on('showLoader', () => {
      this.showLoader();
    });
    EventBus.$on('hideLoader', () => {
      this.hideLoader();
    });
  },
  mounted() {
  },
  methods: {
    triggerAlert(options) {
      this.$refs.alert.showAlert(options);
    },
    showLoader() {
      this.$refs.loader.showLoader();
    },
    hideLoader() {
      this.$refs.loader.hideLoader();
    },
  },
};
</script>
